"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
const lodash_1 = __importDefault(require("lodash"));
// import MobxReactFormDevTools from 'mobx-react-form-devtools';
// import MobxReactFormDevTools from 'mobx-react-form-devtools';
const src_1 = __importDefault(require("../../modules/mobx-react-form-devtools/src")); // load from source
// import MobxReactFormDevTools from '../../modules/mobx-react-form-devtools/lib'; // load from build
const Nav_1 = __importDefault(require("./Nav"));
const Switch_1 = __importDefault(require("./Switch"));
const __forms_1 = __importDefault(require("../forms/_.forms"));
const menu_1 = __importDefault(require("../menu"));
// selected menu item
const selected = $menu => lodash_1.default.keys(lodash_1.default.pickBy($menu, lodash_1.default.identity))[0];
const select = val => src_1.default.select(val);
src_1.default.register(__forms_1.default);
src_1.default.select(selected(menu_1.default));
src_1.default.open(true);
const Container = (0, mobx_react_1.observer)(({ content }) => (react_1.default.createElement("div", { className: "cf helvetica" },
    react_1.default.createElement("div", { className: "fl w-100 w-50-ns measure center ph2 ph5-ns pv5" }, content),
    react_1.default.createElement("div", { className: "fl w-100 w-50-ns" }))));
exports.default = (0, mobx_react_1.observer)(() => (react_1.default.createElement("div", null,
    react_1.default.createElement(src_1.default.UI, null),
    react_1.default.createElement(Nav_1.default, { menu: menu_1.default, select: select, selected: selected(menu_1.default) }),
    react_1.default.createElement(Container, { content: react_1.default.createElement(Switch_1.default, { menu: menu_1.default, forms: __forms_1.default }) }))));
